import { SET_FILTER_TOOLS_STATE, CLEAR_FILTER_TOOLS_STATE } from './filterActionTypes';

export const setFilterToolsState = (bool) => ({
  type: SET_FILTER_TOOLS_STATE,
  payload: bool,           // a true/false
});

export const clearFilterToolsState = () => ({
  type: CLEAR_FILTER_TOOLS_STATE,
});
